// import React from 'react';
// import BaseTabComponent from './../BaseTabComponent';
// import Icon from "../../../Icon";
// import minusIcon from "../../../../svgs/minus-button.svg";
// import plusIcon from "../../../../svgs/plus-button.svg";
// import {addCommasToNumber} from "../../../../utils";

// export default class Marketing extends BaseTabComponent {
//     constructor(props) {
//         super(props);
//         this.onTableValueChange = this.onTableValueChange.bind(this);
//         this.handleExpand = this.handleExpand.bind(this);
//         this.handleExpandShow = this.handleExpandShow.bind(this);
//         window.eventCount=0;
//     }

//     onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
//         this.props.valueChange({
//             tab: 'expenses-tab',
//             table: tableIdentifier,
//             row: rowCode,
//             value: event.currentTarget.value,
//             columnIndex,
//         });
//     }

//     handleExpand() {
//         this.props.handleExpand({
//             tabId: 'marketing-tab',
//             tablesId: ['income-and-expenses', 'proforma-income-and-expenses'],
//             rowsId: {
//                 'income-and-expenses': ['base-rent-additional-price'],
//                 'proforma-income-and-expenses': ['base-rent-additional-price'],
//             },
//         });
//         this.props.setState({isMarketingAdditionalPriceVisible: !this.props.isMarketingAdditionalPriceVisible});
//     }

//     handleExpandShow(toggleState) {
//         this.props.handleExpandShow({
//             tabId: 'marketing-tab',
//             tablesId: ['income-and-expenses', 'proforma-income-and-expenses'],
//             rowsId: {
//                 'income-and-expenses': ['base-rent-additional-price'],
//                 'proforma-income-and-expenses': ['base-rent-additional-price'],
//             },
//             toggleState:!toggleState
//         });
//         this.props.setState({isMarketingAdditionalPriceVisible: toggleState});
//     }

//     renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex, forceStatic) {
//         if (forceStatic) {
//             return (
//                 <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
//                     key={`${rowKey}-${columnIndex}`}>
//                     <span className="text value">{addCommasToNumber(row.value)}</span>
//                 </td>
//             )
//         }
//         return (
//             <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
//                 <label
//                     className={`${row.type} ${(row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps')) ? 'formatted-number-label' : ''}`}>
//                     <input value={row.value}
//                            lang='en-US'
//                            onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
//                            type={row.type}
//                            placeholder={row.unit}/>
//                     <div
//                         className="input-display-value">{addCommasToNumber(row.value)} {row.value ? row.unit : null}</div>
//                 </label>
//             </td>
//         );
//     }

//     renderStaticValueCell(tabs, cell, rowKey, colIndex, precomputedValues) {
//         if(cell.name == 'base-rent-additional-price'){
//             if(cell.getComputedValue && window.eventCount!=1)
//             {               
//                 const additional_pricing_value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[2].value);
//                 if(additional_pricing_value > 0){
//                     window.eventCount=1;
//                     this.handleExpandShow(true);  
//                 }
//             }
//         }
//         if (cell.hidden)
//             return;
//         if (cell.empty)
//             return (<td className='value-cell empty' key={`${rowKey}-${colIndex}`}/>);
//         return (
//             <td className={`value-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
//                 key={`${rowKey}-${colIndex}`}>
//                 <span className='text value'>{cell.getComputedValue(tabs, rowKey, precomputedValues) ? cell.getComputedValue(tabs, rowKey, precomputedValues).displayValue : ""}</span>           
//                 {
//                     cell.hasExpandButton &&
//                     <span className='expand-button' onClick={() => this.handleExpand()}>
//                         <Icon svg={this.props.isMarketingAdditionalPriceVisible ? minusIcon : plusIcon}/>
//                     </span>
//                 }
//                 {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
//             </td>
//         );
//     }

//     renderTable(tables, tableIdentifier, precomputedValues) {
//         const table = tables[tableIdentifier];
//         const tableRows = Object.keys(table.rows).map((key) => {
//             const row = table.rows[key];
//             const nameCell = BaseTabComponent.renderNameCell(row);
//             let valueCell;
//             if (row.editable) {
//                 valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
//             } else {
//                 valueCell = this.renderStaticValueCell(this.props.tabs, row, null, null, precomputedValues);
//             }
//             return (
//                 <tr key={key} className={key}>{nameCell}{valueCell}</tr>
//             );
//         });

//         return (
//             <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
//                 <tbody>
//                 {table.headerRow && table.headerRow.length ?
//                     <tr>{table.headerRow.map((cell, index) => {
//                         return (
//                             <td className='header-cell' key={cell ? cell : index}>
//                                 <div className='text'>{cell}</div>
//                             </td>
//                         )
//                     })}</tr>
//                     : null
//                 }

//                 {tableRows}
//                 </tbody>
//             </table>
//         )
//     }

//     renderMatrixTable(tables, tableIdentifier, precomputedValues, forceStaticCells, nonReimbExpenses) {
//         const table = tables[tableIdentifier];

//         const tableRows = Object.keys(table.rows).map((key) => {
//             const row = table.rows[key];
//             const nameCell = BaseTabComponent.renderNameCell(row);

//             if (['expenses', 'income-and-expenses'].includes(tableIdentifier) && key === 'non-reimbursable-expenses' && !nonReimbExpenses)
//                 return;

//             return <tr key={key} className={key}>
//                 {table.hasNamesColumn ? nameCell : null}

//                 {row && row.valueCells && row.valueCells.map((cell, index) => {
//                     if (cell === null) {
//                         return <td key={index} className='invisible'/>
//                     }
//                     if (cell.hidden && cell.name !== 'base-rent-additional-price') {
//                         return;
//                     }
//                     if (cell.editable) {
//                         return this.renderEditableValueCell(tableIdentifier, key, cell, index, forceStaticCells);
//                     } else {
//                         return this.renderStaticValueCell(this.props.tabs, cell, key, index, precomputedValues);
//                     }
//                 })}
//             </tr>
//         });

//         return (
//             <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
//                 <tbody>
//                 {table.headerRow && table.headerRow.length ?
//                     <tr>{
//                         table.headerRow.map((cell, index) => {
//                             return (
//                                 <td className='header-cell' key={index}>
//                                     <div className='text'>{cell}</div>
//                                 </td>
//                             )
//                         })
//                     }</tr>
//                     : null
//                 }

//                 {tableRows}

//                 {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
//                     <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
//                         const cell = table.footerRow.valueCells[key];
//                         if (cell.empty) {
//                             return (<td className='value-cell empty' key={key}/>)
//                         }
//                         if (cell) {
//                             return (
//                                 <td key={key}>
//                                     <div
//                                         className='text'>{cell.getComputedValue(this.props.tabs, null, precomputedValues).displayValue}</div>
//                                 </td>
//                             );
//                         }
//                         return <td className='invisible' key={key}/>;
//                     })}</tr>
//                     : null
//                 }
//                 </tbody>
//             </table>
//         )
//     }

//     render() {
//         const marketingTab = this.props.tabs['marketing-tab'];
//         const currentRRTab = this.props.tabs['current-rr-tab'];
//         const generalInformation = this.props.tabs['property-information-tab'].tables['general-information'];
//         const nonReimbExpenses = this.props.tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value;
//         const isPricingProforma = !!this.props.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;

//         // Computing heavily-used values at the start of the render.
//         const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

//         return (
//             <div className="Marketing">
//                 <div className="Financials_table_container">
//                     <h3 className="Financials_table_title">{generalInformation.rows['property-name'].value}</h3>
//                     <div className="text">{generalInformation.rows['address'].value}</div>
//                     <div
//                         className="text">{generalInformation.rows['city'].value}, {generalInformation.rows['state'].value}</div>
//                     <div className="tables-flex-row">
//                         <div className="column">
//                             {this.renderTable(marketingTab.tables, 'offering-summary', precomputedValues)}
//                             {this.renderMatrixTable(marketingTab.tables, 'expenses', precomputedValues, null, nonReimbExpenses)}
//                             {isPricingProforma && this.renderMatrixTable(marketingTab.tables, 'proforma-income-and-expenses', precomputedValues, null, nonReimbExpenses)}
//                         </div>
//                         <div className="column">
//                             {this.renderMatrixTable(marketingTab.tables, 'income-and-expenses', precomputedValues, null, nonReimbExpenses)}
//                         </div>
//                     </div>
//                 </div>
//                 <div className="Financials_table_container">
//                     <h3 className="Financials_table_title">Tenants</h3>

//                     <div className="scrollable-tables">
//                         <div className="left-table">
//                             <table className="supra-header">
//                                 <tbody>
//                                 <tr>
//                                     <td/>
//                                 </tr>
//                                 </tbody>
//                             </table>
//                             {this.renderMatrixTable(currentRRTab.tables, 'top-left', precomputedValues)}
//                             {this.renderMatrixTable(currentRRTab.tables, 'general-information', precomputedValues, true)}
//                             {this.renderMatrixTable(currentRRTab.tables, 'sumed-general-information', precomputedValues)}
//                         </div>
//                         <div className="right-table">
//                             <div className="main-table">
//                                 <table className="supra-header rent-roll-supra-header">
//                                     <tbody>
//                                     <tr>
//                                         <td>Rent Roll</td>
//                                     </tr>
//                                     </tbody>
//                                 </table>
//                                 {this.renderMatrixTable(marketingTab.tables, 'rent-roll-header', precomputedValues)}
//                                 {this.renderMatrixTable(marketingTab.tables, 'rent-roll', precomputedValues)}
//                                 {this.renderMatrixTable(marketingTab.tables, 'sumed-rent-roll', precomputedValues)}
//                             </div>
//                             <div className="main-table">
//                                 <table className="supra-header reimbursements-supra-header">
//                                     <tbody>
//                                     <tr>
//                                         <td>Reimbursements</td>
//                                     </tr>
//                                     </tbody>
//                                 </table>
//                                 {this.renderMatrixTable(marketingTab.tables, 'reimbursements-header', precomputedValues)}
//                                 {this.renderMatrixTable(marketingTab.tables, 'reimbursements', precomputedValues)}
//                                 {this.renderMatrixTable(marketingTab.tables, 'sumed-reimbursements', precomputedValues)}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

import React from 'react';
import BaseTabComponent from './../BaseTabComponent';
import Icon from "../../../Icon";
import minusIcon from "../../../../svgs/minus-button.svg";
import plusIcon from "../../../../svgs/plus-button.svg";
import {addCommasToNumber} from "../../../../utils";

export default class Marketing extends BaseTabComponent {
    constructor(props) {
        super(props);
        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleExpandShow = this.handleExpandShow.bind(this);
        window.eventCount=0;
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        this.props.valueChange({
            tab: 'expenses-tab',
            table: tableIdentifier,
            row: rowCode,
            value: event.currentTarget.value,
            columnIndex,
        });
    }

    handleExpand() {
        this.props.handleExpand({
            tabId: 'marketing-tab',
            tablesId: ['income-and-expenses', 'proforma-income-and-expenses'],
            rowsId: {
                'income-and-expenses': ['base-rent-additional-price'],
                'proforma-income-and-expenses': ['base-rent-additional-price'],
            },
        });
        this.props.setState({isMarketingAdditionalPriceVisible: !this.props.isMarketingAdditionalPriceVisible});
    }

    handleExpandShow(toggleState) {
        this.props.handleExpandShow({
            tabId: 'marketing-tab',
            tablesId: ['income-and-expenses', 'proforma-income-and-expenses'],
            rowsId: {
                'income-and-expenses': ['base-rent-additional-price'],
                'proforma-income-and-expenses': ['base-rent-additional-price'],
            },
            toggleState:!toggleState
        });
        this.props.setState({isMarketingAdditionalPriceVisible: toggleState});
    }

    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex, forceStatic) {
        if (forceStatic) {
            return (
                <td className={`value-cell font-size-10 ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className="text value">{row.code==='RR_SUITE_CODE' ? row.value : addCommasToNumber(row.value)}</span>
                </td>
            )
        }
        return (
            <td className='value-cell editable-cell font-size-10' key={`${rowKey}-${columnIndex}`}>
                <label
                    className={`${row.type} ${(row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps')) ? 'formatted-number-label' : ''}`}>
                    <input value={row.value}
                           lang='en-US'
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                           type={row.type}
                           placeholder={row.unit}/>
                    <div
                        className="input-display-value">{addCommasToNumber(row.value)} {row.value ? row.unit : null}</div>
                </label>
            </td>
        );
    }

    renderStaticValueCell(tabs, cell, rowKey, colIndex, precomputedValues, tableIdentifier) {
        if(cell.name == 'base-rent-additional-price'){
            if(cell.getComputedValue && window.eventCount!=1)
            {               
                const additional_pricing_value = Math.round(tabs['pricing-tab'].tables['base-rent'].rows['additional-price'].valueCells[2].value);
                if(additional_pricing_value > 0){
                    window.eventCount=1;
                    this.handleExpandShow(true);  
                }
            }
        }
        if (cell.hidden)
            return;
        if (cell.empty)
            return (<td className='value-cell empty' key={`${rowKey}-${colIndex}`}/>);

        return (
            <td className={`value-cell font-size-10 ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')} ${(['sumed-general-information', 'sumed-rent-roll', 'sumed-reimbursements', 'general-information', 'rent-roll', 'reimbursements'].includes(tableIdentifier))&&cell.nameClasses ? cell.nameClasses: ''}`}
                key={`${rowKey}-${colIndex}`}>
                <span className='text value'>{cell.getComputedValue(tabs, rowKey, precomputedValues) ? cell.getComputedValue(tabs, rowKey, precomputedValues).displayValue : ""}</span>           
                {
                    cell.hasExpandButton &&
                    <span className='expand-button' onClick={() => this.handleExpand()}>
                        <Icon svg={this.props.isMarketingAdditionalPriceVisible ? minusIcon : plusIcon}/>
                    </span>
                }
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderTable(tables, tableIdentifier, precomputedValues) {
        const table = tables[tableIdentifier];
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);
            let valueCell;
            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = this.renderStaticValueCell(this.props.tabs, row, null, null, precomputedValues, tableIdentifier);
            }
            return (
                <tr key={key} className={key}>{nameCell}{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell, index) => {
                        return (
                            <td className={`header-cell font-museo-sans font-size-12`} key={cell ? cell : index}>
                                <div className={`text ${cell==='CURRENT'?'margineLeft':''}`}>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

                {tableRows}
                </tbody>
            </table>
        )
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, forceStaticCells, nonReimbExpenses) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);

            if (['expenses', 'income-and-expenses'].includes(tableIdentifier) && key === 'non-reimbursable-expenses' && !nonReimbExpenses)
                return;

            return <tr key={key} className={key}>
                {table.hasNamesColumn ? nameCell : null}

                {row && row.valueCells && row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }
                    if (cell.hidden && cell.name !== 'base-rent-additional-price') {
                        return;
                    }
                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index, forceStaticCells);
                    } else {
                        return this.renderStaticValueCell(this.props.tabs, cell, key, index, precomputedValues, tableIdentifier);
                    }
                })}
            </tr>
        });
        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{
                        table.headerRow.map((cell, index) => {
                            return (
                                <td className={`header-cell ${['reimbursements-header', 'rent-roll-header', 'top-left'].includes(tableIdentifier)?'font-museo-sans-500 font-size-9':'font-museo-sans font-size-12'}`} key={index}>
                                    <div className={`text ${cell==='CURRENT'?'margineLeft':''}`}>{cell}</div>
                                </td>
                            )
                        })
                    }</tr>
                    : null
                }

                {tableRows}

                {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                    <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                        const cell = table.footerRow.valueCells[key];
                        if (cell.empty) {
                            return (<td className='value-cell empty' key={key}/>)
                        }
                        if (cell) {
                            return (
                                <td key={key} className='font-gotham-bold font-size-10'>
                                    <div
                                        className='text'>{cell.getComputedValue(this.props.tabs, null, precomputedValues).displayValue}</div>
                                </td>
                            );
                        }
                        return <td className='invisible' key={key}/>;
                    })}</tr>
                    : null
                }
                </tbody>
            </table>
        )
    }

    render() {
        const marketingTab = this.props.tabs['marketing-tab'];
        const currentRRTab = this.props.tabs['current-rr-tab'];
        const generalInformation = this.props.tabs['property-information-tab'].tables['general-information'];
        const nonReimbExpenses = this.props.tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value;
        const isPricingProforma = !!this.props.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="Marketing font-gotham">
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title font-gotham-bold font-size-24">{generalInformation.rows['property-name'].value}</h3>
                    <div className="text font-gotham font-size-12">{generalInformation.rows['address'].value}</div>
                    <div
                        className="text font-gotham font-size-12">{generalInformation.rows['city'].value}, {generalInformation.rows['state'].value}</div>
                    <div className="tables-flex-row">
                        <div className="column">
                            {this.renderTable(marketingTab.tables, 'offering-summary', precomputedValues)}
                            {this.renderMatrixTable(marketingTab.tables, 'expenses', precomputedValues, null, nonReimbExpenses)}
                            {isPricingProforma && this.renderMatrixTable(marketingTab.tables, 'proforma-income-and-expenses', precomputedValues, null, nonReimbExpenses)}
                        </div>
                        <div className="column">
                            {this.renderMatrixTable(marketingTab.tables, 'income-and-expenses', precomputedValues, null, nonReimbExpenses)}
                        </div>
                    </div>
                </div>
                <div className="Financials_table_container">
                    {/* <h3 className="Financials_table_title font-museo-sans font-size-12">Tenants</h3> */}

                    <div className="scrollable-tables">
                        <div className="left-table">
                            <table className="supra-header">
                                <tbody>
                                <tr>
                                {/* <td style={{verticalAlign: 'middle'}} className='font-museo-sans font-size-12'>TENANTS</td> */}
                                <td style={{verticalAlign: 'middle'}} className='font-museo-sans font-size-12'>TENANTS</td>
                                </tr>
                                </tbody>
                            </table>
                            {this.renderMatrixTable(currentRRTab.tables, 'top-left', precomputedValues)}
                            {this.renderMatrixTable(currentRRTab.tables, 'general-information', precomputedValues, true)}
                            {this.renderMatrixTable(currentRRTab.tables, 'sumed-general-information', precomputedValues)}
                        </div>
                        <div className="right-table">
                            <div className="main-table">
                                <table className="supra-header rent-roll-supra-header">
                                    <tbody>
                                    <tr>
                                        <td style={{verticalAlign: 'middle'}} className='font-museo-sans font-size-12'>RENT ROLL</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {this.renderMatrixTable(marketingTab.tables, 'rent-roll-header', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'rent-roll', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'sumed-rent-roll', precomputedValues)}
                            </div>
                            <div className="main-table">
                                <table className="supra-header reimbursements-supra-header">
                                    <tbody>
                                    <tr>
                                        <td style={{verticalAlign: 'middle'}} className='font-museo-sans font-size-12'>REIMBURSEMENTS</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {this.renderMatrixTable(marketingTab.tables, 'reimbursements-header', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'reimbursements', precomputedValues)}
                                {this.renderMatrixTable(marketingTab.tables, 'sumed-reimbursements', precomputedValues)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}